import React, { useEffect, useState } from 'react';
// Packages :
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { useNavigate } from 'react-router-dom';

// Componenets :
import Sidebar from '../components/Sidebar';

// Firebase :
import { onRefrech } from '../config/loginConfig';
import { chambersRef } from '../config/firebaseConfig';
import { onValue } from 'firebase/database';

// Icons :
import Eth from '../assets/images/eth.png';
import { FaRegSnowflake } from 'react-icons/fa';
import { GiOrange } from 'react-icons/gi';
import { WiHumidity } from 'react-icons/wi';
import { PiFanLight } from 'react-icons/pi';
import { FaDoorClosed, FaDoorOpen } from 'react-icons/fa';
import { AiFillAlert } from "react-icons/ai";

const Chambres = () => {
    const [ch1, setCh1] = useState([]);
    const [ch2, setCh2] = useState([]);
    const [ch3, setCh3] = useState([]);
    const [ch4, setCh4] = useState([]);
    const [ch5, setCh5] = useState([]);
    const [ch6, setCh6] = useState([]);
    const [ch7, setCh7] = useState([]);
    const [ch8, setCh8] = useState([]);
    const [ch9, setCh9] = useState([]);
    const [ch10, setCh10] = useState([]);
    const [ch11, setCh11] = useState([]);

    useEffect(() => {
        const unsubscribe = onValue(chambersRef, (snapshot) => {
            const data = snapshot.val();

            setCh1(data?.chamber1 || []);
            setCh2(data?.chamber2 || []);
            setCh3(data?.chamber3 || []);
            setCh4(data?.chamber4 || []);
            setCh5(data?.chamber5 || []);
            setCh6(data?.chamber6 || []);
            setCh7(data?.chamber7 || []);
            setCh8(data?.chamber8 || []);
            setCh9(data?.chamber9 || []);
            setCh10(data?.chamber10 || []);
            setCh11(data?.chamber11 || []);
        });

        // Cleanup function to unsubscribe from the listener when the component unmounts
        return () => unsubscribe();
    }, []);

    const rooms = [
        { id: 'ch1', data: ch1, name: 'CH 01', realTimeName: 'chamber1' },
        { id: 'ch2', data: ch2, name: 'CH 02', realTimeName: 'chamber2' },
        { id: 'ch3', data: ch3, name: 'CH 03', realTimeName: 'chamber3' },
        { id: 'ch4', data: ch4, name: 'CH 04', realTimeName: 'chamber4' },
        { id: 'ch5', data: ch5, name: 'CH 05', realTimeName: 'chamber5' },
        { id: 'ch6', data: ch6, name: 'CH 06', realTimeName: 'chamber6' },
        { id: 'ch7', data: ch7, name: 'CH 07', realTimeName: 'chamber7' },
        { id: 'ch8', data: ch8, name: 'CH 08', realTimeName: 'chamber8' },
        { id: 'ch9', data: ch9, name: 'CH 09', realTimeName: 'chamber9' },
        { id: 'ch10', data: ch10, name: 'CH 10', realTimeName: 'chamber10' },
        { id: 'ch11', data: ch11, name: 'CH 11', realTimeName: 'chamber11' }
    ];

    useEffect(() => {
        const CheckRefresh = async () => {
            const id = await localStorage.getItem('id');
            await onRefrech(id);
        }
        CheckRefresh();
    }, []);

    const navigate = useNavigate();

    const handleCardClick = (room) => {
        navigate(`/dashboard/${room.id}`, { state: { room: room.data, roomName: room.name, id: room.id, realTimeName: room.realTimeName } });
    };

    // ============================================================================== //

    // Check if any alarm is active :
    const isAnyAlertActive = (room) => room?.data?.Alarmes?.length > 0;

    return (
        <div className="flex lg:gap-5 bg-[#fffcf6]">
            <Sidebar />
            <main className="flex-1 mx-auto py-4 pr-4 pl-4 lg:pl-0 h-screen overflow-y-scroll">
                <p className='text-4xl lg:text-5xl font-bold mb-4 text-center md:text-left'>Dashboard</p>

                <div className="mt-8 flex flex-wrap">
                    {rooms.map(room => (
                        <div key={room.id} className='w-full lg:w-1/4 py-2 lg:p-2'>
                            <div onClick={() => handleCardClick(room)} className='cursor-pointer bg-white p-4 rounded-lg shadow-md'>

                                <div className={`flex justify-between items-center border-primary border-b-2 pb-4`}>
                                    <div></div>
                                    <p className='text-2xl lg:text-4xl font-bold text-center'>{room.name}</p>
                                    <div>
                                        <Tooltip title={`${room?.data?.Alarmes?.length > 0 ? `${room?.data?.Alarmes?.length} Alarmes` : 'No Alarmes'}`}>
                                            <IconButton>
                                                <AiFillAlert className={`${isAnyAlertActive(room) ? 'alert-icon' : 'text-gray'}`} size={30} />
                                            </IconButton>
                                        </Tooltip>
                                    </div>
                                </div>

                                <div>
                                    <div className='mt-4 flex justify-between items-center'>
                                        <div className='w-4/5 pr-2 lg:pr-4 flex justify-between items-center'>
                                            <div>
                                                <p className='text-sm'>Température (<sup>o</sup>C)</p>
                                                <p className='text-sm mt-4'>Humidité (%)</p>
                                                <p className='text-sm mt-4'>CO<sub>2</sub> (ppm)</p>
                                                <p className='text-sm mt-4'>Éthylène (ppm)</p>
                                            </div>

                                            <div>
                                                <p className='text-lg lg:text-xl font-semibold'>{room?.data?.data?.temp || '-'}</p>
                                                <p className='text-lg lg:text-xl font-semibold mt-2 lg:mt-3'>{room?.data?.data?.hum || '-'}</p>
                                                <p className='text-lg lg:text-xl font-semibold mt-2 lg:mt-3'>{room?.data?.data?.co2 || '-'}</p>
                                                <p className='text-lg lg:text-xl font-semibold mt-2 lg:mt-3'>{room?.data?.data?.eth || '-'}</p>
                                            </div>

                                            <div>
                                                <p className='text-sm lg:text-base text-gray'>
                                                    {room?.data?.consignes?.tempconsigne !== undefined
                                                        ? room.data.consignes.tempconsigne === '-'
                                                            ? room.data.consignes.tempconsigne
                                                            : room.data.consignes.tempconsigne + '*'
                                                        : '-'}
                                                </p>
                                                <p className='text-sm lg:text-base text-gray mt-4'>
                                                    {room?.data?.consignes?.humconsigne !== undefined
                                                        ? room.data.consignes.humconsigne === '-'
                                                            ? room.data.consignes.humconsigne
                                                            : room.data.consignes.humconsigne + '*'
                                                        : '-'}
                                                </p>
                                                <p className='text-sm lg:text-base text-gray mt-4'>
                                                    {room?.data?.consignes?.co2consigne !== undefined
                                                        ? room.data.consignes.co2consigne === '-'
                                                            ? room.data.consignes.co2consigne
                                                            : room.data.consignes.co2consigne + '*'
                                                        : '-'}
                                                </p>
                                                <p className='text-sm lg:text-base text-gray mt-4'>
                                                    {room?.data?.consignes?.ethconsigne !== undefined
                                                        ? room.data.consignes.ethconsigne === '-'
                                                            ? room.data.consignes.ethconsigne
                                                            : room.data.consignes.ethconsigne + '*'
                                                        : '-'}
                                                </p>
                                            </div>
                                        </div>

                                        <div className='w-1/5'>
                                            <div className='p-1' title='Conservation'>
                                                <div className={`${room?.data?.mode?.conservsign === "on" ? "bg-primary" : "bg-lightgray"} rounded-md p-2 flex items-center justify-center`}><FaRegSnowflake color='white' size={32} /></div>
                                            </div>
                                            <div className='p-1' title='Déverdissage' >
                                                <div className={`${room?.data?.mode?.deversign === "on" ? "bg-primary" : "bg-lightgray"} rounded-md p-2 flex items-center justify-center`}><GiOrange color='white' size={32} /></div>
                                            </div>
                                            <div className='p-1' title='Forcage'>
                                                <div className={`${room?.data?.mode?.Forcage === "on" ? "bg-primary" : "bg-lightgray"} rounded-md p-2 flex items-center justify-center text-white font-bold text-2xl`} >F</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='flex justify-between'>
                                        <div className='p-1 w-1/5' title="Électrovanne de humidité" >
                                            <div className={`${room?.data?.status?.humsign === "on" ? 'bg-primary' : 'bg-lightgray'} h-14 rounded-md flex items-center justify-center`}><WiHumidity color='white' size={35} /></div>
                                        </div>
                                        <div className='p-1 w-1/5' title="Extracteur d'air">
                                            <div className={`${room?.data?.status?.faninsign === "on" ? 'bg-primary' : 'bg-lightgray'} flex-col h-14 rounded-md flex items-center justify-center`}>
                                                <PiFanLight color='white' size={35} />
                                                <p className='text-white text-sm'>In</p>
                                            </div>
                                        </div>
                                        <div className='p-1 w-1/5' title="Extracteur d'air">
                                            <div className={`${room?.data?.status?.fanoutsign === "on" ? 'bg-primary' : 'bg-lightgray'} flex-col h-14 rounded-md flex items-center justify-center`}>
                                                <PiFanLight color='white' size={35} />
                                                <p className='text-white text-sm'>Out</p>
                                            </div>
                                        </div>
                                        <div className='p-1 w-1/5' title='Porte de chambre'>
                                            <div className={`${room?.data?.status?.doorsign === "on" ? 'bg-primary' : 'bg-lightgray'} h-14 rounded-md flex items-center justify-center`}>
                                                {room?.data?.status?.doorsign === "on" ? (
                                                    <FaDoorOpen color='white' size={35} />
                                                ) : (
                                                    <FaDoorClosed color='white' size={35} />
                                                )}
                                            </div>
                                        </div>
                                        <div className='p-1 w-1/5' title='Électrovanne de Éthylène'>
                                            <div className={`${room?.data?.status?.ethsign === "on" ? 'bg-primary' : 'bg-lightgray'} h-14 rounded-md flex items-center justify-center`}><img src={Eth} alt="" width={30} /></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

            </main>
        </div>
    );
}

export default Chambres;